import React, { createContext, useContext, useState, useCallback } from 'react';

const PoDetailContext = createContext(null);

export const PoDetailProvider = ({ children }) => {
  const [poData, setPoData] = useState({
    po_status: null,
    total_gross: null,
    total_quantity: null,
    total_weight: null,
  });

  const updatePoData = useCallback(data => {
    setPoData({
      po_status: data.po_status,
      total_gross: data.total_gross,
      total_quantity: data.total_quantity,
      total_weight: data.total_weight,
    });
  }, []);

  return (
    <PoDetailContext.Provider value={{ poData, updatePoData }}>
      {children}
    </PoDetailContext.Provider>
  );
};

export const usePoDetailContext = () => useContext(PoDetailContext);

export default PoDetailProvider;
